const createFacilityStockReport = async (mainApi, { locationId, programId, serviceId, stockData }) => {
  // Get current reporting period
  const period = await mainApi.report.period.get({
    programId,
    date: new Date(),
    isEffectiveDate: false
  })

  // Get service and product details
  const [service, productDocs] = await Promise.all([
    mainApi.service.get(serviceId),
    mainApi.product.listForServices([serviceId])
  ])

  // Transform CSV data into stock format
  const stockReport = {}

  // Initialize stock report with default values for products
  productDocs.forEach(product => {
    stockReport[product._id] = {
      fields: {
        'field:standard-opening-balance': {
          disabled: false
        }
      },
      disabled: true
    }
  })

  // Update products with data from CSV
  stockData.forEach(row => {
    Object.entries(row).forEach(([key, value]) => {
      if (key === 'productId' || key === 'productName') return
      // This is to handle remark field if empty
      // we do not want to set it to empty string
      if (value !== '') {
        stockReport[row.productId].fields[key] = {
          amount: key === 'field:standard-remark' ? value : parseFloat(value),
          disabled: key === 'field:standard-received'
        }
      }
    })
    stockReport[row.productId].disabled = false
  })

  // Save report
  const result = await mainApi.report.save({
    locationId,
    service,
    stock: stockReport,
    period,
    submittedAt: new Date(),
    partialCount: false
  })

  return result
}

module.exports = {
  createFacilityStockReport
}
